// DTOs and enums for the manual-id-verification feature.
// Ported from ops-portal/src/app/model/ and src/app/model/enum/.

export enum ManualIdVerificationStatusEnum {
  ALL = 'all',
  VERIFIED = 'verified',
  REJECTED = 'rejected',
  PENDING = 'pending',
  BLOCKED = 'blocked',
}

export enum IdentityVerificationStatusEnum {
  NOT_VERIFIED = 'NOT_VERIFIED',
  IN_PROGRESS = 'IN_PROGRESS',
  REJECTED = 'REJECTED',
  APPROVED_VERIFIED = 'APPROVED_VERIFIED',
  BLOCKED = 'BLOCKED',
}

export enum IdDocumentTypeEnum {
  ALL = 'All',
  NATIONAL_IDENTITY_CARD = 'NATIONAL_IDENTITY_CARD',
  PASSPORT = 'PASSPORT',
  RECEIPT = 'RECEIPT',
}

export interface AirtableAttachment {
  id: string;
  url: string;
  filename: string;
  type: string;
  width?: number;
  height?: number;
  thumbnails?: Record<string, { url: string; width: number; height: number }>;
}

// Intentional typo preserved from source filename (manual-id-verification-record-fileds.ts)
export interface ManualIdVerificationRecordFields {
  'User Id': string;
  'Business Entity ID'?: string[];
  'Business Name'?: string[];
  'Business Regulatory Status'?: string[];
  'Company Name'?: string;
  'Birth Date'?: string;
  Email: string;
  'First Name': string;
  'Id Doc': AirtableAttachment[];
  'Id Document Type': string;
  'Id Document Verification Status': string;
  'Id Document Number'?: string;
  'Id Document Expiry Date'?: string;
  'Last Name': string;
  'Onfido Check Result'?: AirtableAttachment[];
  Role: string;
  'Selfie Photo': AirtableAttachment[];
  'Place of birth'?: string;
  Gender: string;
  'Reason for rejection'?: string;
  Note?: string;
  'User Language'?: string;
  Nationality?: string;
  'Issuing Country'?: string;
  'Issuing Date'?: string;
  // Language field (note: Angular code references both 'Language' and 'language' — accept both)
  Language?: string;
  language?: string;
}

export interface ManualIdVerificationRecord {
  id: string;
  fields: ManualIdVerificationRecordFields;
  createdTime: string;
}

export interface ManualIdVerificationStats {
  verified: number;
  rejected: number;
  needHelp: number;
  waitingForValidation: number;
}

export interface Country {
  id: number;
  name: string;
  iso2: string;
  iso3: string;
  phoneCode: string;
  capital: string;
  currency: string;
}

export interface RejectionReason {
  id: string;
  description: string;
}
